"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ColorConversions {
    /**
     *
     * @static
     * @param {RGB} rgb
     * @returns {HEX}
     * @memberof ColorConversions
     */
    static rgbToHex(rgb) {
        return `#${ColorConversions.toHex(rgb.r)}${ColorConversions.toHex(rgb.g)}${ColorConversions.toHex(rgb.b)}`;
    }
    /**
     *
     * @private
     * @static
     * @param {number} value
     * @returns
     * @memberof ColorConversions
     */
    static toHex(value) {
        const hex = value.toString(16);
        return hex.length == 2 ? hex : '0' + hex;
    }
    /**
     *
     *
     * @static
     * @param {(Types.Color.HEX | Array<string>)} hex
     * @returns {Types.Color.RGB}
     * @memberof ColorConversions
     */
    static hexToRgb(hex) {
        hex = typeof hex === 'string' ? hex.match(/[a-zA-Z0-9]{2}/gi) : hex;
        return {
            r: ColorConversions.hexToDec(hex[0]),
            g: ColorConversions.hexToDec(hex[1]),
            b: ColorConversions.hexToDec(hex[2])
        };
    }
    /**
     * Converte un esadecimale in un decimale
     *
     * @static
     * @param {string} str
     * @returns {number}
     * @memberof ColorConversions
     */
    static hexToDec(str) {
        return parseInt(ColorConversions.fill2(str), 16);
    }
    /**
     * Dublica il carattere se è singolo
     *
     * @static
     * @param {string} str
     * @returns {string}
     * @memberof ColorConversions
     */
    static fill2(str) {
        return str.length == 1 ? str + str : str;
    }
    /**
     *
     *
     * @static
     * @param {Types.Color.RGB} rgb
     * @returns {Types.Color.HSL}
     * @memberof ColorConversions
     */
    static rgbToHsl(rgb) {
        let r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255;
        const max = Math.max(r, g, b), min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;
        if (max == min) {
            h = s = 0; // achromatic
        }
        else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return { h, s, l };
    }
    /**
     *
     *
     * @static
     * @param {Types.Color.HSL} hsl
     * @returns {Types.Color.RGB}
     * @memberof ColorConversions
     */
    static hslToRgb(hsl) {
        let h = hsl.h, s = hsl.s, l = hsl.l, r, g, b;
        if (s == 0) {
            r = g = b = l; // achromatic
        }
        else {
            const hue2rgb = ((p, q, t) => {
                t += t < 0 ? 1 : t > 1 ? -1 : 0;
                if (t < 1 / 6)
                    return p + (q - p) * 6 * t;
                if (t < 1 / 2)
                    return q;
                if (t < 2 / 3)
                    return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            });
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
    }
    /**
     *
     *
     * @static
     * @param {Types.Color.RGB} rgb
     * @returns {Types.Color.HSV}
     * @memberof ColorConversions
     */
    static rgbToHsv(rgb) {
        let r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255;
        const max = Math.max(r, g, b), min = Math.min(r, g, b);
        let h, s, v = max;
        const d = max - min;
        s = max == 0 ? 0 : d / max;
        if (max == min) {
            h = 0; // achromatic
        }
        else {
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return { h, s, v };
    }
    /**
     *
     *
     * @static
     * @param {Types.Color.HSV} hsv
     * @returns {Types.Color.RGB}
     * @memberof ColorConversions
     */
    static hsvToRgb(hsv) {
        let h = hsv.h, s = hsv.s, v = hsv.v, r, g, b;
        const i = Math.floor(h * 6);
        const f = h * 6 - i;
        const p = v * (1 - s);
        const q = v * (1 - f * s);
        const t = v * (1 - (1 - f) * s);
        switch (i % 6) {
            case 0:
                r = v, g = t, b = p;
                break;
            case 1:
                r = q, g = v, b = p;
                break;
            case 2:
                r = p, g = v, b = t;
                break;
            case 3:
                r = p, g = q, b = v;
                break;
            case 4:
                r = t, g = p, b = v;
                break;
            case 5:
                r = v, g = p, b = q;
                break;
        }
        return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
    }
    /**
     *
     *
     * @static
     * @param {Types.Color.RGB} rgb
     * @returns {Types.Color.CMYK}
     * @memberof ColorConversions
     */
    static rgbToCmyk(rgb) {
        let r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255;
        let cmyk = { k: null, c: null, m: null, y: null };
        cmyk.k = +(1 - Math.max.call(null, r, g, b));
        cmyk.c = +((1 - r - cmyk.k) / (1 - cmyk.k));
        cmyk.m = +((1 - g - cmyk.k) / (1 - cmyk.k));
        cmyk.y = +((1 - b - cmyk.k) / (1 - cmyk.k));
        return cmyk;
    }
    /**
     *
     *
     * @static
     * @param {Types.Color.CMYK} cmyk
     * @returns {Types.Color.RGB}
     * @memberof ColorConversions
     */
    static cmykToRgb(cmyk) {
        return {
            r: 255 * (1 - cmyk.c) * (1 - cmyk.k),
            g: 255 * (1 - cmyk.m) * (1 - cmyk.k),
            b: 255 * (1 - cmyk.y) * (1 - cmyk.k)
        };
    }
}
exports.default = ColorConversions;
//# sourceMappingURL=ColorConversions.js.map